"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vuexModuleDecorators = require("vuex-module-decorators");
var _clients = require("@/api/clients");
var _industries = require("@/api/industries");
var _index = _interopRequireDefault(require("@/components/HelpText/index.vue"));
var _utils = require("@/utils");
var _common = require("@/api/common");
var _vueAdvancedCropper = require("vue-advanced-cropper");
require("vue-advanced-cropper/dist/style.css");
var _index2 = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _companies = require("@/api/master/companies");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.clientData = Object.assign({}, _clients.defaultClientData);
    this.companiesList = [];
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        message: 'Minimum length should be 3',
        trigger: 'blur'
      }],
      contactNumber: [{
        pattern: /^\d+$/,
        message: 'Please enter numbers only',
        trigger: 'blur'
      }, {
        min: 10,
        max: 10,
        message: 'Length should be 10',
        trigger: 'blur'
      }],
      emailAddress: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        type: 'email',
        message: 'Please enter correct email address',
        trigger: ['blur']
      }],
      gstNumber: {
        pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        message: 'Enter a valid GST number',
        trigger: 'blur'
      },
      panNumber: {
        pattern: /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/,
        message: 'Enter a valid PAN number',
        trigger: 'blur'
      },
      companyId: [{
        required: true,
        message: 'Company is required',
        trigger: 'change'
      }]
    };
    this.image = {
      src: '',
      type: ''
    };
    this.cropperVisible = false;
    this.imageSrc = '';
    this.selectedFile = null;
    this.logoUrl = '';
    this.logo = [];
    // Dealer, Distributer, Retailer, Reseller, Corporate Customer
    this.industriesList = [];
  }
  // 1️⃣ When user selects file
  onFileSelected(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.selectedFile = file;
    const reader = new FileReader();
    reader.onload = e => {
      this.imageSrc = e.target.result;
      this.cropperVisible = true;
    };
    reader.readAsDataURL(file);
  }
  // 2️⃣ Crop image
  cropImage() {
    const cropper = this.$refs.cropper;
    const canvas = cropper.getResult().canvas;
    canvas.toBlob(async blob => {
      var _this$selectedFile;
      const formData = new FormData();
      formData.append('file', blob, (_this$selectedFile = this.selectedFile) === null || _this$selectedFile === void 0 ? void 0 : _this$selectedFile.name);
      const response = await (0, _common.uploadFile)(formData);
      this.formData.logo = response;
      this.cropperVisible = false;
    }, 'image/png');
  }
  triggerFileInput() {
    this.$refs.fileInput.click();
  }
  async getCompanys() {
    const companies = await (0, _companies.getCompanies)({
      sort: 'id,ASC',
      filter: 'enabled||$eq||true'
    });
    this.companiesList = companies;
    const qCompanyId = this.$route.query.companyId;
    if (qCompanyId && !this.isEdit) {
      this.clientData.companyId = Number(qCompanyId);
    }
  }
  // Load image from disk
  loadImage(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.image.type = file.type;
    const reader = new FileReader();
    reader.onload = e => {
      this.image.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }
  // Crop & Upload
  async cropAndUpload() {
    const cropper = this.$refs.cropper;
    const {
      canvas
    } = cropper.getResult();
    // Resize to 32x32
    const resizedCanvas = document.createElement('canvas');
    resizedCanvas.width = 32;
    resizedCanvas.height = 32;
    const ctx = resizedCanvas.getContext('2d');
    ctx.drawImage(canvas, 0, 0, 32, 32);
    resizedCanvas.toBlob(async blob => {
      const formData = new FormData();
      formData.append('file', blob, 'logo.png');
      try {
        // const response = await axios.post('/common/upload', formData)
        // this.logoUrl = response.data.url
        // this.$emit('logoUploaded', this.logoUrl)
        this.image.src = '';
      } catch (error) {
        console.error('Upload failed', error);
      }
    }, 'image/png');
  }
  submitForm() {
    this.$refs.clientFormRef.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        // this.$message.error("Failed to saved!");
        return false;
      }
    });
  }
  created() {
    this.getIndustries();
    this.getCompanys();
    // ✅ GET QUERY DATA
    const query = this.$route.query;
    if (query.email || query.name) {
      this.clientData.emailAddress = query.email || '';
      this.clientData.name = query.name || '';
    }
  }
  onFormDataChange(val) {
    if (this.isEdit && val && val.id) {
      this.clientData = Object.assign({}, val);
      if (val.logo) {
        this.logo = [{
          name: val.name,
          url: val.logo
        }];
      }
    }
  }
  emitFormData() {
    this.$emit('updated', this.clientData);
  }
  logoUploaded(file) {
    this.formData.logo = file.response;
    this.clientData.logo = file.response;
  }
  async getIndustries() {
    try {
      this.industriesList = await (0, _industries.getIndustries)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$message.error(error.toString());
    }
  }
  async saveForm() {
    this.loading = true;
    try {
      let response = {};
      if (this.isEdit) {
        response = await (0, _clients.updateClient)(this.clientData.id, this.clientData);
        this.$emit('reload', true);
      } else {
        response = await (0, _clients.createClient)(this.clientData);
        this.clientData = response;
        this.emitFormData();
        // 🔥 👉 ADD THIS BLOCK (MAIN LOGIC)
        if (this.$route.query.from === 'addToLead') {
          this.$router.push({
            path: '/clients-contacts/add',
            query: {
              email: this.clientData.emailAddress,
              clientId: String(this.clientData.id),
              from: 'addToLead',
              step: 'contact'
            }
          });
          return; // ❗ VERY IMPORTANT
        }
        // to make other tabs available
        this.$emit('edited', true);
      }
      this.$notify({
        title: 'Success',
        message: 'Client saved!',
        type: 'success',
        duration: 2000
      });
    } catch (err) {
      this.$notify.error(err.toString());
    } finally {
      this.loading = false;
    }
  }
  resetForm() {
    this.$refs.clientFormRef.resetFields();
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: {}
})], default_1.prototype, "formData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('formData', {
  deep: true,
  immediate: true
})], default_1.prototype, "onFormDataChange", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientGeneralTab',
  components: {
    HelpText: _index.default,
    FileUpload: _index2.default,
    Cropper: _vueAdvancedCropper.Cropper
  }
})], default_1);
var _default = exports.default = default_1;